export default {
    /**
     * @static
     * @type {number}
     * @default 1664
     */
    STAGE_WIDTH: 1792,

    /**
     * @static
     * @type {number}
     * @default 768
     */
    STAGE_HEIGHT: 768,

    /**
     * @static
     * @type {Object}
     */
    config: {},

    /**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
     */
    renderer: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    stage: null,

    /**
     * @static
     * @type {P3.Ticker}
     */
    ticker: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    transitions: null,

    /**
     * @static
     * @type {number}
     */
    userId: 0,

    /**
     * @static
     * @type {number}
     * @default 0
     */
    locationIndex: 1,

    /**
     * @static
     * @type {Object}
     */
    location: {},

    /**
     * @static
     * @type {Object}
     */
    character: {},

    /**
     * @static
     * @type {AchievementSystem}
     */
    achievements: null,

    /**
     * @static
     * @type {boolean}
     */
    debug: false,

    /**
     * @static
     * @type {Object}
     */
    gui: null,

    /**
     * @static
     * @type {Object}
     */
    requiredAssetsReady: false,

    /**
     * @static
     * @type {number}
     */
    days: 0,

    /**
     * @static
     * @type {number}
     */
    date: 0,

    /**
     * @static
     * @type {number}
     */
    weekday: 0,

    /**
     * @static
     * @type {number}
     */
    week: 0,

    /**
     * @static
     * @type {number}
     */
    year: 0,

    /**
     * @static
     * @type {number}
     */
    equipmentAchievement: -1
}